import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { ACCOUNT_TYPE } from "../../../utils/constants";

function ProtectedRouteForInstructor({ children }) {
    const { user } = useSelector((state) => state.profile);
    if (user?.accountType === ACCOUNT_TYPE.INSTRUCTOR) {
        return children;
    } else {
        return <Navigate to="/dashboard/profile" />;
    }
}

export default ProtectedRouteForInstructor;